import { Injectable } from '@angular/core';

import type { GoogleMap } from '@lib/geo/google/map';

import { FsMapOffendersServiceProvider, IFsMap } from '@lib/geo/core';

@Injectable()
export class MapOffendersFacadeService<TMap extends IFsMap> extends FsMapOffendersServiceProvider<TMap> {
  constructor(private readonly provider: FsMapOffendersServiceProvider<TMap>) {
    super();
  }

  public get isAvailable(): boolean {
    return this.provider.isAvailable;
  }

  public get offenderClustering(): boolean {
    return this.provider.offenderClustering;
  }

  public set offenderClustering(value: boolean) {
    this.provider.offenderClustering = value;
  }

  public onMapLoaded(map: TMap): void {
    this.provider.onMapLoaded(map);
  }

  public select(): void {
    this.provider.select();
  }

  public addToMap(): void {
    this.provider.addToMap();
  }

  public removeFromMap(): void {
    this.provider.removeFromMap();
  }

  public viewOffender(id: string): void {
    this.provider.viewOffender(id);
  }

  public setOffenderClustering(enabled: boolean): void {
    this.provider.setOffenderClustering(enabled);
  }
}
